import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetPortalUsuarios } from '../../shared/interfaces/database/seguridad';

@Injectable({
  providedIn: 'root'
})
export class PortalUsuarioService {
  private readonly baseUrl = `${environment.apiUrl}/api/seguridad/portal-usuario`;

  constructor(private readonly http: HttpClient) { }

  public getPortalUsuarios(): Observable<IGetPortalUsuarios[]> {
    return this.http.get<IGetPortalUsuarios[]>(`${this.baseUrl}`);
  }

}
